import * as app from '../services/app';
import { ActionTypes } from '../types/action-types';

export const expandConfigView = (isExpanded: boolean) => ({
    type: ActionTypes.ADOBE_UI_UPDATED,
    configuredExpanded: isExpanded
});

export const installSchema = (enable: boolean) => async dispatch => {
    if (enable) {
        await app.installContextPluginSchema();
        dispatch({
            type: ActionTypes.ADOBE_SCHEMA_INSTALLED,
            schemaInstalled: true
        });
    } else {
        await app.uninstallContextPluginSchema();
        dispatch({
            type: ActionTypes.ADOBE_SCHEMA_INSTALLED,
            schemaInstalled: false
        });
        dispatch({
            type: ActionTypes.ADOBE_UI_UPDATED,
            configuredExpanded: false
        });
    }
};




// WEBPACK FOOTER //
// ./src/sub-projects/adobe/actions/app.ts